<template>
    <div id="UpdateNewHvutAsset">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> {{pageTitle}} </div>
                    <div class="btn-groups text-right">
                        <button id="cancelHvutCostBtn" class="btn btn-tertiary" v-on:click.prevent="backBtn()">
                            <i class="fp-close"> </i> Cancel
                        </button>
                        <button v-if="flag == 'update'" type="submit" id="createHvutCostBtn" class="btn btn-primary" v-on:click.prevent="updateCost()">
                          <i class="fp-reload"> </i>  Update
                        </button>
                        <button v-if="confirmFHUTUnits && flag != 'update'" id="confirmFHUTUnits" v-on:click.prevent="loadList('confirm')" class="btn btn-primary">
                          Confirm FHUT Units
                        </button>
                        <button type="button" v-if="flag != 'update'" id="gotocnfunits" class="btn btn-tertiary" v-on:click.prevent="gotoCnfUnits()">
                          Go to Confirmed Fhut Units <i style="font-size:18px;padding-left:2px;" class="fp-right-arrow"> </i>
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content hvut-schedule-crud">
                        <data-table-filter-config :moduleName="'newassetHVUTList'" :allowSameFilter="'allow'" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'newassetHVUTList'" :position="'top'">
                                </custom-pagination>

                                 <vue-good-table
                                    ref="UpdateHVUTTable"
                                    mode="remote"
                                    title="FHUT"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: confirmFHUTUnits,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    >
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'hvut_cost'" class='text-center form-group mb-0'>
                                                <template v-if="flag == 'update'">
                                                    <template v-if="props.row.status.toLowerCase() != 'processed'">
                                                        <input type="text" style="width:auto;" class="form-control text-right pull-right" :id="'cost'+props.row.id" v-model="props.row.hvut_cost" @keypress="isAmountCheck($event)"/>
                                                    </template>
                                                    <template v-else>
                                                        {{props.formattedRow[props.column.field]}}
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    {{props.formattedRow[props.column.field]}}
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from ".././event-bus";


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

    export default {
        name: "UpdateNewHvutAsset",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Update New FHUT Asset | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Unit Number',
                    field: 'unit_no',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Year',
                    field: 'year',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Date In Service',
                    field: 'date_in_service',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Date In Service", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:true
                },
                {
                    label: 'Start Date',
                    field: 'start_date',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Start Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'End Date',
                    field: 'end_date',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "End Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Cost',
                    field: 'hvut_cost',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Cost", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },

                {
                    label: 'FHUT Category',
                    field: 'hvut_category',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "FHUT Category", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },

                },
                {
                    label: 'Gross Weight',
                    field: 'gvw',
                    hidden:false,
                    fpFieldType:"integer",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Gross Weight", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },

            ],
            totalRecords: 0,
            term_value: false,
            loading:false,
            rows:[],
            serverParams: {
                columnFilters: {},
                sort: {
                    field: "id",
                    type: "asc"
                },
                page: 1,
                perPage: 100
            },
            schedule:'',
            flag:"add",
            pageTitle:"New FHUT Asset",
            schedule_date:"",
            start_date:"",
            start_date_error_msg:"",
            loggedinUserId: '',
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
            },
            confirmFHUTUnits: false,
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_hvut_schedule') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_hvut_schedule') {
                            self.term_value = true;
                        }
                      if (permissions[i].name == 'add_hvut_schedule') {
                            self.confirmFHUTUnits = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //if user logged in than remove login button and registration button
            var userObj = localStorage.getItem("user_obj");

            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                if (userJson.roles.length > 0) {
                    self.loggedinUserId = userJson.id;
                }
            }

            // self.loadNewHvutList();
            if (self.$route.params.flag != undefined) {
                if (self.$route.params.flag != null && self.$route.params.flag != "") {
                    if (self.$route.params.flag == "update") {
                        self.flag = "update";
                        self.pageTitle = "Update FHUT Asset";
                        for(var i = 0; i < self.columns.length;i++) {
                            if (self.columns[i] != undefined) {
                                if (self.columns[i] != null) {
                                    if (self.columns[i].field != null) {
                                        if (self.columns[i].field == "year") {
                                            self.columns[i].sortable = true;
                                        }
                                    }
                                }
                            }
                        }
                        //status column in update fhut list
                        self.columns.push({
                            label: 'Status',
                            field: 'status',
                            hidden:false,
                            fpFieldType:"option",
                            filterable: true,
                            filterOptions: {
                                enabled: false, // enable filter for this column
                                placeholder: "Status", // placeholder for filter input
                                filterDropdownItems: ['Entry','Processed'],
                                trigger: "enter" //only trigger on enter not on keyup
                            }
                        });
                    }
                }
            }
            self.getPermissions();
        },
        metaInfo() {
            return {
                title: (this.flag == "update") ?"Update FHUT Asset | " +process.env.COPYRIGHT_NAME:"New FHUT Asset | " +process.env.COPYRIGHT_NAME
            }
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.UpdateHVUTTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            loadList(flag) {

                var self = this;
                var currentFlag = flag;
                self.loading = true;

                //pass update flag when request send from update page
                var checkUpdateScreen = self.$route.params.flag;
                if ( checkUpdateScreen ) {
                    currentFlag = self.$route.params.flag;
                }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: currentFlag ? currentFlag : 'list',
                    schedule_date:(self.start_date != null && self.start_date != "")?self.start_date:"",
                    userId: self.loggedinUserId
                };
                self.firstLoad = 1;
                var listUrl = "/new-hvut-schedule/list";
                if (self.flag == "update") {
                    listUrl = "/hvut-schedule/list";
                }
                if(currentFlag == 'confirm'){
                  self.$swal({
                    title: 'Are you sure that you want to move this to Confirmed FHUT Units?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                  }).then((result) => {
                    if (result.value) {
                      var data = this.$refs['UpdateHVUTTable'].selectedRows;
                      var use = [];
                      var confirmFields = {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        sort: self.serverParams.sort,
                        flag: currentFlag ? currentFlag : 'list',
                        schedule_date:(self.start_date != null && self.start_date != "")?self.start_date:"",
                        userId: self.loggedinUserId,
                        ids: use,
                      };
                      for (var i = 0; i < data.length; i++) {
                          use.push(this.$refs['UpdateHVUTTable'].selectedRows[i].id)
                      }
                      $.ajax({
                          url: process.env.ROOT_API + listUrl,
                          type: "POST",
                          data:confirmFields,
                          headers: this.ajxHeaders,
                          dataType: "json",
                          success: function (data) {
                              self.loading = false;
                              if (data.status == "success") {
                                  self.rows = data.content.row;
                                  console.log(self.rows);
                                  self.totalRecords = data.content.totalRecords;
                                  self.loadList('list');
                              }
                          },
                          error: function (jqXHR, exception) {
                              self.loading = false;
                              if (jqXHR.status == 0) {
                                  self.errorMsg = "Remote server cannot be reached";
                              } else {
                                  //redirect to login page if user not authenticated
                                  if (jqXHR.status == 401) {
                                      //clear previous data
                                      localStorage.removeItem("user_obj");
                                      localStorage.removeItem("tkn");

                                      self.$router.push("/");
                                  }
                                  self.error = jqXHR.responseJSON.message;
                              }
                          }
                      });
                    }else{
                      self.loading = false;
                    }
                  });

                }else{
                  $.ajax({
                      url: process.env.ROOT_API + listUrl,
                      type: "POST",
                      data:fields,
                      headers: this.ajxHeaders,
                      dataType: "json",
                      success: function (data) {
                          self.loading = false;
                          if (data.status == "success") {
                              self.rows = data.content.row;
                              console.log(self.rows);
                              self.totalRecords = data.content.totalRecords;
                              if (self.flag != "update") {
                                  self.schedule = data.schedule;
                                  if (data.schedule_date != undefined && data.schedule_date != null) {
                                      self.schedule_date = data.schedule_date;
                                  }
                              }
                          }
                      },
                      error: function (jqXHR, exception) {
                          self.loading = false;
                          if (jqXHR.status == 0) {
                              self.errorMsg = "Remote server cannot be reached";
                          } else {
                              //redirect to login page if user not authenticated
                              if (jqXHR.status == 401) {
                                  //clear previous data
                                  localStorage.removeItem("user_obj");
                                  localStorage.removeItem("tkn");

                                  self.$router.push("/");
                              }
                              self.error = jqXHR.responseJSON.message;
                          }
                      }
                  });
                }
            },

            updateCost: function(){
                var self = this;
                var field = [];
                var items = [];
                var error = false;
                self.start_date_error_msg = "";
                if (self.flag != "update") {
                    if (!self.start_date || self.start_date == null || self.start_date == "") {
                        self.start_date_error_msg = "Schedule Start Date Required.";
                        error = true;
                    }else{
                        var currentDate = new Date();
                        var currentMonth = currentDate.getMonth() + 1;
                        var currentYear = currentDate.getFullYear();
                        if (currentMonth < 7) {
                            var previousYear = moment().subtract(1, 'years').format('Y');
                            var fhutStartDate = new Date(previousYear,6,1);
                            var fhutEndDate = new Date(currentYear,5,30);

                            if (Date.parse(self.start_date) < Date.parse(fhutStartDate) || Date.parse(self.start_date) > Date.parse(fhutEndDate)) {
                                self.start_date_error_msg = "Select Schedule Start Date According To FHUT Year.";
                                error = true;
                            }

                        }else{
                            var nextYear = moment().add(1, 'years').format('Y');
                            var fhutStartDate = new Date(currentYear,6,1);
                            var fhutEndDate = new Date(nextYear,5,30);

                            if (Date.parse(self.start_date) < Date.parse(fhutStartDate) || Date.parse(self.start_date) > Date.parse(fhutEndDate)) {
                                self.start_date_error_msg = "Select Schedule Start Date According To FHUT Year.";
                                error = true;
                            }
                        }
                    }
                }

                if (!error) {
                    if (self.flag == "update") {
                        for(var i = 0; i < self.rows.length; i++){

                            if ( $("#cost"+self.rows[i].id).val() > 0){
                                if (self.rows[i].status != null) {
                                    if (self.rows[i].status != null) {
                                        if (self.rows[i].status != "processed") {
                                            var arr = {};
                                            arr['id'] = self.rows[i].id;
                                            arr['cost'] = $("#cost"+self.rows[i].id).val();
                                            items.push(arr);
                                        }
                                    }
                                }
                            }
                        }
                    }else{
                        var assetArr = [];
                        for(var i = 0; i < self.rows.length; i++){
                            if ( $("#cost"+self.rows[i].id).val() > 0){
                                self.rows[i].cost = $("#cost"+self.rows[i].id).val();
                                items.push(self.rows[i]);
                                assetArr.push(self.rows[i].id);
                            }
                        }
                        if (self.serverParams.columnFilters.length > 0) {
                            field = {
                                page:self.serverParams.page,
                                perPage:self.serverParams.perPage,
                                filters:self.serverParams.columnFilters,
                                sort:self.serverParams.sort,
                                all:"no",
                                asset:"",
                                start_date:self.start_date,
                                from:self.flag,
                                rows:JSON.stringify(items)
                            }
                        }else{
                            field = {
                                page:self.serverParams.page,
                                perPage:self.serverParams.perPage,
                                filters:self.serverParams.columnFilters,
                                sort:self.serverParams.sort,
                                all:"yes",
                                asset:JSON.stringify(assetArr),
                                start_date:self.start_date,
                                from:self.flag,
                                rows:JSON.stringify(items)
                            }
                        }
                        $("#saveButtonFhut").prop("disabled", true);
                        $("#cancelBtnFhut").prop("disabled", true);
                    }

                    if (self.flag == "update") {
                        field.push({name:'rows',value:JSON.stringify(items)});
                        field.push({name:'from',value:self.flag});
                    }

                    self.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/hvut-cost/update",
                        type: "POST",
                        data: field,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);

                            if (self.flag != "update") {
                                $("#saveButtonFhut").prop("disabled", false);
                                $("#cancelBtnFhut").prop("disabled", false);
                            }

                            // self.rows = data.content.row;
                            if (data.code == '200') {

                                // self.loadList();
                                if (self.flag != 'update') {
                                    self.hideMessageModal();
                                }
                                self.$router.push('/fhut-schedule/list');
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (self.flag != "update") {
                                $("#saveButtonFhut").prop("disabled", false);
                                $("#cancelBtnFhut").prop("disabled", false);
                            }
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('tkn');

                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }
            },

            backBtn: function(){
                var self = this;

                self.$router.push('/fhut-schedule/list');
            },
            gotoCnfUnits: function(){
              var self = this;
              self.$router.push('/confirmed-fhut-units/list');
            },
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/hvut/UpdateNewHvutAsset.vue